import PsychologyIcon from "@mui/icons-material/Psychology";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

import "./AIMLSection.css";

function AIMLSection() {
    return (
        <section className="course-content-section ai-ml-section">

            <div className="content-layout">

                {/* =================================================
                    MAIN CONTENT
                ================================================== */}

                <div className="content-main">

                    {/* <div className="content-label">
                        ARTIFICIAL INTELLIGENCE & MACHINE LEARNING
                    </div> */}

                    <h3>
                        Build the Future with
                        <span>
                            {" "}AI & ML
                        </span>
                    </h3>

                    <p className="content-intro">
                        Develop practical AI and Machine
                        Learning skills and work on
                        real-world applications.
                    </p>

                    <div className="benefits-grid">

                        <Benefit text="Earn ₹18–₹25 LPA with strong AI/ML skills and access to high-value technology roles." />

                        <Benefit text="AI/ML powers real-world solutions such as fraud detection, diagnostics and intelligent assistants." />

                        <Benefit text="Massive talent gap creates opportunities for skilled AI and GenAI professionals." />

                        <Benefit text="AI and ML are foundations for future technologies including GenAI, robotics and automation." />

                        <Benefit text="Build practical skills through projects rather than learning only theory." />

                    </div>

                </div>


                {/* =================================================
                    SIDE CONTENT
                ================================================== */}

                <div className="content-side">

                    <div className="side-card ai-card">

                        <div className="side-card-icon">
                            <PsychologyIcon />
                        </div>

                        <h4>
                            AI & ML Training
                        </h4>

                        <p>
                            Choose the learning path that
                            matches your career goal.
                        </p>


                        <a
                            href="/ai-courses-pay-after-learn"
                            className="mini-course-link"
                        >
                            <span>
                                AI Course
                            </span>

                            <ArrowForwardIcon />
                        </a>


                        <a
                            href="/machine-learning-courses-pay-after-learn"
                            className="mini-course-link"
                        >
                            <span>
                                ML Course
                            </span>

                            <ArrowForwardIcon />
                        </a>

                    </div>

                </div>

            </div>


            {/* =================================================
                FOOTER
            ================================================== */}

             

        </section>
    );
}


/* =========================================================
   REUSABLE BENEFIT
========================================================= */

function Benefit({ text }) {

    return (
        <div className="benefit-item">

            <CheckCircleIcon />

            <span>
                {text}
            </span>

        </div>
    );
}


export default AIMLSection;